export default "__VITE_ASSET__DFYbnEMv__"